module.exports = __webpack_public_path__ + "static/tabs-label-length-do-854cdf3b971a0c7a7d4480a38c5d8c49.png";